var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"hello"},[_c('h2',[_vm._v(_vm._s(_vm.time))]),_c('code',[_vm._v(_vm._s(_vm.getTask.name))]),_c('div')])
}
var staticRenderFns = []

export { render, staticRenderFns }